import { render, staticRenderFns } from "./PaxHome.vue?vue&type=template&id=5029dea8&"
import script from "./PaxHome.vue?vue&type=script&lang=js&"
export * from "./PaxHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports